// extracted by mini-css-extract-plugin
export default {"resume-section":"Resume_resume-section__Is9ej","resume":"Resume_resume__dKx+d","btn":"Resume_btn__Ln3Ox"};